import { useState } from "react";

import { getSession } from "next-auth/react";
import classNames from "classnames";
import Carousel from "react-gallery-carousel";
import "react-gallery-carousel/dist/index.css";

import { customSeoConfig } from "../../utils/helpers/helpers";
import { apiWrapper } from "../../utils/api/apiWrapper";
import {
  kGalleryDetailURL,
  kGalleryTotalViewsUpdateURL,
} from "../../utils/constants/apiUrls";
import NoTextNavBackground from "../../components/common/NoTextNavBackground";
import GallerySliderWithThumbnail from "../../components/common/slider/GallerySliderWithThumbnail";
import NewsDetailAuthorAndDate from "../../components/elements/news/NewsDetailAuthorAndDate";
import GrayHorizontalDivider from "../../components/common/GrayHorizontalDivider";
import NotifyToastContainer, {
  notify,
} from "../../components/common/NotifyToastContainer";
import SocialShareIcons from "../../components/common/icons/SocialShareIcons";
import CopyToClipboard from "react-copy-to-clipboard";
import WebShareIcon from "../../components/common/icons/WebShareIcon";
import { BsLink45Deg } from "react-icons/bs";

const GalleryDetail = ({ galleryData, userGalleryViewed }) => {
  const userViewedGallery = userGalleryViewed?.viewed_galleries;
  const galleryDetail = galleryData?.gallery;
  const galleryImages = galleryData?.gallery_images;

  const {
    first_name: firstName,
    last_name: lastName,
    profile_picture: avatar,
  } = galleryDetail.created_by;

  const authorName = `${firstName} ${lastName}`;

  const gallery = galleryImages.map(function (item, index) {
    return { src: item.image };
  });

  const title = galleryDetail.title;
  const caption = galleryDetail.caption;
  const url = galleryDetail.public_url;

  const [value, setValue] = useState(url);
  const [copied, setCopied] = useState(false);

  return (
    <>
      <NoTextNavBackground />

      {customSeoConfig(
        galleryDetail.title,
        galleryDetail.caption,
        galleryDetail.thumbnail,
        url,
        "article"
      )}

      {/* Gallery carousel */}
      <div>
        <Carousel
          images={gallery}
          isLoop={false}
          style={{
            height: 500,
            width: "auto",
            maxWidth: "65ch",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        />
      </div>

      <div className="px-6 sm:px-0 md:px-0 lg:px-0 xl:px-0 2xl:px-0 mt-6 mb-4 max-w-prose mx-auto">
        <div className="flex justify-center items-center sm:items-end space-x-2 pt-5 sm:py-10">
          <SocialShareIcons title={title} caption={caption} url={url} />

          <CopyToClipboard
            text={value}
            onCopy={() => {
              setCopied({ copied: true });
              setValue(url);
            }}
          >
            <BsLink45Deg
              onClick={notify}
              size={30}
              className={classNames(
                copied ? "text-green-600" : "",
                "cursor-pointer text-gray-500 hover:text-black"
              )}
            />
          </CopyToClipboard>

          <WebShareIcon title={title} caption={caption} url={url} />
        </div>
      </div>

      <NewsDetailAuthorAndDate
        authorAvatar={avatar}
        authorFullName={authorName}
        articleDateTime={galleryDetail.published_on}
      />

      <GrayHorizontalDivider />

      {copied ? <NotifyToastContainer /> : null}

      <div className="sm:pb-5 md:pb-10 lg:pb-10 xl:pb-10 2xl:pb-20"></div>
    </>
  );
};

export default GalleryDetail;

export const getServerSideProps = async (context) => {
  const guestUserToken = process.env.GUSET_USER_TOKEN
    ? process.env.GUSET_USER_TOKEN
    : GUEST_TOKEN;

  const data = await getSession(context);

  const userToken = data?.accessToken ? data.accessToken : guestUserToken;

  const gallerySlug = context.query.slug;

  const { req, res } = context;

  res.setHeader(
    "Cache-Control",
    "public, s-maxage=86400, stale-while-revalidate=60"
  );

  const userGalleryViewed = await apiWrapper.get(
    kGalleryTotalViewsUpdateURL + `?slug=${gallerySlug}`,
    userToken
  );

  const gallery = await apiWrapper.get(
    kGalleryDetailURL + `?slug=${gallerySlug}`,
    userToken
  );

  return {
    props: {
      userGalleryViewed: userGalleryViewed?.data,
      galleryData: gallery?.data,
    },
  };
};
